import { useHttpClient } from '../../http/index';
import { CreateCompensationParams, GetPaymentsResponse } from './types';

const { get, post } = useHttpClient();

const REQUEST_TYPES = {
  CREATE_COMPENSATION: 'create_payment_commission_compensation_request',
};

const fixFileType = (file: File): File => {
  if (file.type === '' || file.type === 'application/octet-stream') {
    const extension = file.name.split('.').pop()?.toLowerCase();
    // heic, heif форматы криво распознаются браузером, без условия ниже на бек улетит application/octet-stream
    if (extension === 'heic' || extension === 'heif') {
      return new File([file], file.name, { type: 'image/heif' });
    }
  }
  return file;
};

export const useCommissionCompensationApi = () => {
  const getPayments = async () => {
    const { data } = await get<GetPaymentsResponse>('/v2/pc/payments?status[]=payed&type[]=card&type[]=bank');

    return data;
  };

  const postCreateCompensationRequest = async ({
    paymentUuid,
    amount,
    document,
    additionalDocument,
  }: CreateCompensationParams) => {
    const formData = new FormData();

    formData.append('data[type]', REQUEST_TYPES.CREATE_COMPENSATION);
    formData.append('data[attributes][amount]', amount.toString());
    formData.append('data[attributes][document]', fixFileType(document), document.name);

    if (additionalDocument) {
      formData.append('data[attributes][additional_document]', fixFileType(additionalDocument), document.name);
    }

    const data = await post(`/v1/office/payments/${paymentUuid}/commission_compensations`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  };

  return {
    getPayments,
    postCreateCompensationRequest,
  };
};
